import { apiClient } from '@/core/infra_api_client'

// ============= Types =============

export type ImageStatus = 'pending' | 'building' | 'available' | 'failed' | 'deprecated'

export interface PackerImage {
  id: string
  name: string
  version: string
  cloudProvider: string
  region: string
  imageId: string
  status: ImageStatus
  sizeGb?: number
  config: Record<string, unknown>
  createdAt: string
  updatedAt: string
  createdBy: string
}

export interface TriggerBuildRequest {
  name: string
  version: string
  cloudProvider: string
  region: string
  config?: Record<string, unknown>
}

export interface PaginatedResponse<T> {
  data: T[]
  total: number
  page: number
  perPage: number
  totalPages: number
}

// ============= API =============

const BASE_PATH = 'images'

export interface AzureGalleryCatalog {
  gallery: string
  region: string
  images: { id: string; name: string; version: string; architecture: string }[]
}

export async function listAzureGalleryImages(credentialId: string, region: string): Promise<AzureGalleryCatalog> {
  return apiClient.get<AzureGalleryCatalog>(`${BASE_PATH}/azure-gallery`, {
    credential_id: credentialId,
    region,
  })
}

export async function listImages(params?: {
  page?: number
  perPage?: number
  status?: string
  cloudProvider?: string
}): Promise<PaginatedResponse<PackerImage>> {
  const searchParams: Record<string, string | number | boolean> = {}
  if (params?.page) searchParams['page'] = params.page
  if (params?.perPage) searchParams['per_page'] = params.perPage
  if (params?.status) searchParams['status'] = params.status
  if (params?.cloudProvider) searchParams['cloud_provider'] = params.cloudProvider

  return apiClient.get<PaginatedResponse<PackerImage>>(BASE_PATH, searchParams)
}

export async function getImage(id: string): Promise<PackerImage> {
  return apiClient.get<PackerImage>(`${BASE_PATH}/${id}`)
}

export async function triggerBuild(data: TriggerBuildRequest): Promise<PackerImage> {
  return apiClient.post<PackerImage, TriggerBuildRequest>(`${BASE_PATH}/build`, data)
}
